export default __webpack_public_path__ + "static/media/work-history.a566475d.svg";